// extracted by mini-css-extract-plugin
export default {"container":"k1-z","list":"l1-z"};